<template>
  <div class="container is-fluid">
    <back-link/>

    <b-tabs v-model="activeTab">
      <b-tab-item label="Common">
        <common-settings/>
      </b-tab-item>
      <b-tab-item label="Users">
        <user-settings/>
      </b-tab-item>
    </b-tabs>

  </div>
</template>

<script>
import CommonSettings from '@/components/CommonSettings'
import UserSettings from '@/components/UserSettings'
import BackLink from '@/components/BackLink'

export default {
  name: 'AdminPage',
  components: {
    CommonSettings,
    UserSettings,
    BackLink
  },
  data () {
    return {
      activeTab: 0
    }
  }
}
</script>

<style scoped>

</style>
